import React from 'react'
import MainLayout from '../common/protected/main-layout/MainLayout'

export default function Dashboard() {
  return <MainLayout>Dashboard</MainLayout>
}
